import letterHead from '@/assets/letterhead.png';

interface FlowableTaskLayoutProps {
  headerLeft?: React.ReactNode;
  headerRight?: React.ReactNode;
  subHeader?: React.ReactNode;
  children: React.ReactNode;
}

export default function FlowableTaskLayout({ headerLeft, headerRight, subHeader, children }: FlowableTaskLayoutProps) {
  return (
    <div className="min-h-screen bg-canvas flex flex-col">
      {/* Header Section */}
      <div className="border-b border-low bg-[linear-gradient(180deg,_#EFF5FF_-66.34%,_#F7F5F1_100%)]">
        <div className="w-full h-[60px] bg-navigation-bar/[0.48] border-b border-low">
          <div className="relative flex items-center justify-between w-full max-w-[1024px] h-full mx-auto">
            <img src={letterHead} className="w-[72px] absolute z-[101] left-1/2 transform -translate-x-1/2" />
            <div className="flex items-center gap-4">{headerLeft}</div>
            <div className="flex items-center gap-4">{headerRight}</div>
          </div>
        </div>

        {subHeader && (
          <div className="w-full h-[164px]">
            <div className="flex items-end w-full max-w-[1024px] h-full mx-auto p-8">{subHeader}</div>
          </div>
        )}
      </div>

      {/* Main Content Section */}
      <div className="flex-1 py-8 max-w-[1024px] mx-auto w-full px-4">{children}</div>
    </div>
  );
}
